import React from "react"
import { Link, navigate } from "gatsby"
import styled from "@emotion/styled"
import { connect } from "react-redux";
import transform_functions from "yaytext-transform";
import * as clipboard from "clipboard-polyfill/text"
import { toast } from 'react-toastify';
class TransformRow extends React.PureComponent {

  getText(){
    return (' ' + (this.props.textarea || this.props.loadingText)).slice(1);
  }
  getTransformedText() {
    let text = this.getText();
    let actions = this.props.transform.actions;
    actions.forEach(function(action){
      text = transform_functions[action.action](text, action);
    });
    return text;
  }
  getPreviewButton(){
    if (!this.props.transform.hasPreviewImages) {
      return ``;
    }
    return (
        <button onClick={() => {
          navigate(`/${this.props.transform.textStyle.path}/#preview_${this.props.transform.slug}`);
          (typeof window !== "undefined" && window.gtag && window.gtag("event", "preview", {
            'event_category': 'Transform Action',
            'event_label': this.props.transform.slug
          }))
        }} className="preview button">
          {this.props.data.preview.string}
        </button>
      )
  }
  getTransformLabel(){
    if (this.props.pageContext.textStyleId && !this.props.forceRowLink) {
      return <div
        className="name"
        dangerouslySetInnerHTML={{
          __html: this.props.transform.label
        }} />;
    } else {
      return <div className="name">
        <Link to={`/${this.props.transform.textStyle.path}/`} dangerouslySetInnerHTML={{
          __html: this.props.transform.label
        }} />
      </div>;
    }
  }
  render() {
    let text = this.getText();
    let transformedText = this.getTransformedText();
    return (
      <Wrapper className="section">
        <div className="transform_row_anchor" id={`render_${this.props.transform.slug}`}/>
        <div className="section_inner">
          { this.getTransformLabel() }
          <div className="example">
            <div className="buttons">
              { this.getPreviewButton() }
              {` `}
              <button className="copy button" onClick={() => {
                let text = this.getText();
                let slug = this.props.transform.slug;
                this.props.copy({
                  date : new Date().toISOString(),
                  text : transformedText,
                  ogText: text,
                  transform: slug
                });
                clipboard.writeText(transformedText);
                toast(this.props.data.notifyCopied.string);
                (typeof window !== "undefined" && window.gtag && window.gtag("event", "copy", {
                  'event_category': 'Transform Action',
                  'event_label': slug
                }))
              }} disabled={!text}>
                {
                  this.props.lastCopy
                  && text
                  && this.props.lastCopy.ogText === text
                  && this.props.lastCopy.transform === this.props.transform.slug
                  ? this.props.data.copiedExclamation.string
                  : this.props.data.copy.string
                }
              </button>
              {` `}
              <button className="tweet button" onClick={() => {
                var url = "https://twitter.com/intent/tweet?text="+encodeURIComponent(transformedText)+" via http://yaytext.com";
                window.open(url, '_blank');
                (typeof window !== "undefined" && window.gtag && window.gtag("event", "tweet", {
                  'event_category': 'Transform Action',
                  'event_label': this.props.transform.slug
                }))
              }}>
                {this.props.data.tweet.string}
              </button>
            </div>
            <span className={`value_inner ${this.props.transform.previewFont}`}>
              {transformedText}
            </span>
          </div>
        </div>
      </Wrapper>
    )
  }
}

const Wrapper = styled("div")`
.section_inner {
  @media screen and (max-width: 600px) {
    position: relative;
    min-height: 80px;
  }
}
.name {
  float: left;
  width: 29%;
  padding-right: .5em;
  box-sizing: border-box;
  @media screen and (max-width: 600px) {
    width: calc(100% - 80px);
    margin: 0 0 .2em;
    padding-right: 0;
  }
}
.name a { color: #000; border-bottom: 1px solid #2B5E65; text-decoration: none; }
.example {
  float: left; width: 71%;
  @media screen and (max-width: 600px) {
    width: calc(100% - 80px);
    font-size: 16px;
  }
}
.example .value_inner {white-space: pre-wrap; display: block; }
.buttons {
  float: right; position: relative;
  @media screen and (max-width: 600px) {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.buttons button {
	font: inherit;
	font-family: "Times New Roman";
	padding: 2px 4px;
	font-size: 13px;
  background: rgba(255, 255, 255, 0.2);
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    font-size: 16px; float: left; clear: left; margin: 0 0 2px; width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.buttons button:hover {background: rgba(255, 255, 255, 0.3)}
.buttons .after_copy {
	display: inline-block;
	position: absolute;
	bottom: 24px;
	width: 270px;
	right: 0;
	font-size: 18px;
	padding: 10px;
}
.buttons .after_copy button {
	position: absolute;
	bottom: 2px;
	right: 2px;
	background: white;
	font-size: 11px;
}
`

export default connect(state => ({
  textarea : state.textarea,
  loadingText : state.loadingText,
  lastCopy: state.lastCopy
}), dispatch => {
  return {
		copy: (copyData) => dispatch({ type: `COPY`, copy: copyData }),
	}
})(TransformRow);
